import {
  clearAdminToken,
  getAdminToken,
} from "./adminSession";

export const SESSION_EXPIRED_MESSAGE =
  "Session expired, please login again...";
export const SESSION_EXPIRED_NOTICE_KEY = "sessionExpiryNotice";

const getDefaultNoticeStorage = () => window.sessionStorage;
const defaultRedirect = (path) => window.location.replace(path);

export const installSessionExpiryInterceptor = (
  client,
  {
    getToken = getAdminToken,
    clearToken = clearAdminToken,
    noticeStorage = getDefaultNoticeStorage(),
    redirect = defaultRedirect,
  } = {}
) => {
  let handlingExpiry = false;

  return client.interceptors.response.use(
    (response) => response,
    (error) => {
      const isUnauthorized = error?.response?.status === 401;
      const hasAuthenticatedSession = Boolean(getToken());

      if (isUnauthorized && hasAuthenticatedSession && !handlingExpiry) {
        handlingExpiry = true;
        clearToken();
        noticeStorage.setItem(
          SESSION_EXPIRED_NOTICE_KEY,
          SESSION_EXPIRED_MESSAGE
        );
        redirect("/login");
      }

      return Promise.reject(error);
    }
  );
};

export const consumeSessionExpiryNotice = (
  storage = getDefaultNoticeStorage()
) => {
  const notice = storage.getItem(SESSION_EXPIRED_NOTICE_KEY);

  if (notice) {
    storage.removeItem(SESSION_EXPIRED_NOTICE_KEY);
    return notice;
  }

  return null;
};
